module.exports = __webpack_public_path__ + "static/media/rralogofinal_green.cf92a57e.png";